export default __webpack_public_path__ + "static/Domovea_05-7e3710c9cda33d71bf4a64a87c19c8f4.webp";